import { createSlice } from "@reduxjs/toolkit"
import { createJob, interviewListingForJob, matchJobToResumes, retrieveJob, retrieveJobs, updateJob } from "./JobAction"
import { Job, ResumeMatchingResult } from "./interface"

const initialState = {
  job: {} as Job,
  jobList: [],
  interviewList: [],
  matchedResumes: [] as ResumeMatchingResult[],
  refetchRequired: false,
  totalRecords: undefined,
}

const jobSlicer = createSlice({
  name: 'job',
  initialState,
  reducers: {
    reset: (state: any) => {
      state.job = {} as Job
    },
  },
  extraReducers: (builder) => {
    builder
      .addCase(retrieveJobs.fulfilled, (state: any, { payload }) => {
        state.jobList = payload.content
        state.totalRecords = Number(payload.totalElements)
      })
      .addCase(retrieveJobs.pending, (state: any, { payload }) => {
        state.jobList = []
        state.totalRecords = undefined
      })
      .addCase(retrieveJob.fulfilled, (state: any, { payload }) => {
        state.job = payload
      })
      .addCase(createJob.fulfilled, (state: any, { payload }) => {
        state.job = payload
      })
      .addCase(updateJob.fulfilled, (state: any, { payload }) => {
        state.job = payload
      })
      .addCase(matchJobToResumes.pending, (state: any, { payload }) => {
        state.matchedResumes = []
        state.totalRecords = undefined
        state.refetchRequired = false
      })
      .addCase(matchJobToResumes.fulfilled, (state: any, { payload }) => {
        state.matchedResumes = payload.matchResults.content
        state.totalRecords = Number(payload.matchResults.totalElements)
        state.refetchRequired = payload.refetchRequired
      })
      .addCase(interviewListingForJob.fulfilled, (state: any, { payload }) => {
        state.interviewList = payload.content
        state.totalRecords = Number(payload.totalElements)
      })
      .addCase(interviewListingForJob.pending, (state: any, { payload }) => {
        state.interviewList = []
        state.totalRecords = undefined
      })
  },
})

export const { reset } = jobSlicer.actions;
export default jobSlicer.reducer